import { defineMessages, type IntlShape } from 'react-intl';
import type { JSONSchema } from '@plone/types';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const addBlocksFullWidth = ({
  schema,
  formData,
  intl,
}: {
  schema: JSONSchema;
  formData: JSONSchema;
  intl: IntlShape;
}): JSONSchema => {
  addStyling({ schema, intl, formData });

  // @ts-expect-error
  schema.properties.styles.schema.fieldsets[0].fields = [
    // @ts-expect-error
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'fullwidth',
  ];
  // @ts-expect-error
  schema.properties.styles.schema.properties['fullwidth'] = {
    type: 'boolean',
    title: intl.formatMessage(messages.full_width_block_title),
  };

  return schema;
};

export default addBlocksFullWidth;
const messages = defineMessages({
  full_width_block_title: {
    id: 'full_width_block_title',
    defaultMessage: 'Show block as full-width',
  },
});
